(function() {
    'use strict';

    angular
        .module('awizApp')
        .constant('paginationConstants', {
            'itemsPerPage': 50
        });
})();
